// extracted by mini-css-extract-plugin
export default {"LoginImageContainer":"Login_styles_LoginImageContainer__0FYpg","LoginCentre":"Login_styles_LoginCentre__wUY0M"};